<span class="inline">
  <button (click)="viewNotes()">
    @if (notes.length == 0) {
      <svg-icon icon="icon-notepad" class="small"></svg-icon>
    }
    @if (notes.length > 0) {
      <svg-icon icon="icon-notepad-alert" class="small"></svg-icon>
    }
  </button>
</span>